export default __webpack_public_path__ + "static/media/026.86351bd7.jpg";